export default __webpack_public_path__ + "static/media/weather.a05d843a.PNG";